export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'edtUzivatel';
export const NAME = 'UzivatelskyProfil';
export const MENU_CODE = 'UzivProfil';
export const TABS_WITH_PERMISSION=['cmdAdvancePay'];
export const SUB_MENU_ID_PROP='SubMenuId';

export enum TAB_NAMES {
	NASTAVENI1 = 'Nastaveni1',
	NASTAVENI2 = 'Nastaveni2',
	NASTAVENI3 = 'Nastaveni3',
	ROZHRANI = 'Rozhrani',
	DISCOUNTCONFIG = 'DiscountConfig',
	MENUOPERATIONS = 'MenuOperations',
	MENUTABS = 'MenuTabs',
	SUBSTRINGSM = 'SubStringSM',
	SUBSTRINGOV = 'SubStringOV',
	SUBSTRINGNV = 'SubStringNV',
}
export enum UserProfileValid {
	LoginInvalid = 1,
	WorkerInvalid = 2,
}

export const TABS = {
	[TAB_NAMES.NASTAVENI1]: { id: TAB_NAMES.NASTAVENI1, labelKey: 'Nastaveni1' },
	[TAB_NAMES.NASTAVENI2]: { id: TAB_NAMES.NASTAVENI2, labelKey: 'Nastaveni2' },
	[TAB_NAMES.NASTAVENI3]: { id: TAB_NAMES.NASTAVENI3, labelKey: 'Nastaveni3' },
	[TAB_NAMES.ROZHRANI]: { id: TAB_NAMES.ROZHRANI, labelKey: 'pageUzivatelRozhrani' },
	[TAB_NAMES.DISCOUNTCONFIG]: { id: TAB_NAMES.DISCOUNTCONFIG, labelKey: 'discountConfig' },
	[TAB_NAMES.MENUOPERATIONS]: { id: TAB_NAMES.MENUOPERATIONS, labelKey: 'MenuOperations' },
	[TAB_NAMES.MENUTABS]: { id: TAB_NAMES.MENUTABS, labelKey: 'MenuTabs' },
	[TAB_NAMES.SUBSTRINGSM]: { id: TAB_NAMES.SUBSTRINGSM, labelKey: 'modulSM' },
	[TAB_NAMES.SUBSTRINGOV]: { id: TAB_NAMES.SUBSTRINGOV, labelKey: 'modulOV' },
	[TAB_NAMES.SUBSTRINGNV]: { id: TAB_NAMES.SUBSTRINGNV, labelKey: 'modulNV' },
};
export enum ADVANCE_PAYMNET
	{
	MainMenuText = 'Servis',
	SubMenuText = 'cmdAdvancePay',
}
